(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('ProfileLinkedinDialogController', ProfileLinkedinDialogController);

    ProfileLinkedinDialogController.$inject = ['$scope', '$timeout', 'Linkedin', 'Auth'];

    function ProfileLinkedinDialogController($scope, $timeout, Linkedin, Auth) {
        var vm = this;

        vm.file = null;
        vm.save = save;
        vm.isSuccess = false;
        vm.isError = false;
        
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });


        function save () {
            if (!vm.file){
                onSaveError();
                return;
            }
            vm.isSuccess = false;
            vm.isError = false;
            vm.isSaving = true;
            var fd = new FormData();
            fd.append('file', vm.file);

            Linkedin.importContacts({}, fd).$promise
                .then(onSaveSuccess)
                .catch(onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('quilinkApp:profileUpdate', result);
            // Reset profile but not identity
            Auth.authorize(false, true).then(function () {
               // $uibModalInstance.close(result);
                vm.isSaving = false;
                vm.isSuccess = true;
                vm.isError = false;
            });
        }

        function onSaveError () {
            vm.isSaving = false;
            vm.isSuccess = false;
            vm.isError = true;
        }
    }
})();
